import {
  SET_CAPITALIZATION_OF_EARNINGS,
} from "./mutations";

const initialState = {
  capitalizationOfEarnings: null
};

const capitalizationOfEarningsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_CAPITALIZATION_OF_EARNINGS: {
      return { ...state, capitalizationOfEarnings: payload };
    }

    default:
      return state;
  }
};

export default capitalizationOfEarningsReducer;
